// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:host {
  display: block;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;
  font-family: "Segoe UI", "Roboto", Helvetica, Arial, sans-serif;
}

/* ---------- Main wrapper: single-column player card ---------- */
.embed-preview {
  padding: 10px;
  background: #f1f5f9;
  border-radius: 20px;
  max-width: 720px;
  margin: 0 auto;
  box-sizing: border-box;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
}

.epv-player {
  background: #ffffff;
  padding: 15px;
  border-radius: 14px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  box-sizing: border-box;
  min-width: 0;
}

.epv-header {
  margin-bottom: 16px;
  text-align: left;
}

/* Flow title */
.epv-title-row {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}

.epv-title {
  margin: 0;
  width: 100%;
  min-width: 0;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.3;
  color: #0f0f0f;
  font-family: "Raleway", sans-serif;
  letter-spacing: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.epv-title--expanded {
  white-space: normal;
  overflow: visible;
  text-overflow: unset;
}
.epv-title--clickable {
  cursor: pointer;
}
.epv-title--clickable:focus-visible {
  outline: 2px solid #0284c7;
  outline-offset: 2px;
  border-radius: 4px;
}

.epv-meta-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 4px;
  width: 100%;
}

.epv-author {
  margin: 0;
  font-size: 13px;
  color: #64748b;
  flex: 0 1 auto;
  min-width: 0;
}

/* Step title line (below the flow title) */
.epv-steptitle {
  display: block;
  margin-top: 6px;
  font-size: 14px;
  font-weight: 600;
  color: #000000;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.epv-autoplay {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
  margin-left: auto;
  padding: 0;
  margin-bottom: 0;
  border: 0 !important;
  outline: 0 !important;
  box-shadow: none !important;
  background: transparent !important;
  -webkit-tap-highlight-color: transparent;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.epv-autoplay:focus, .epv-autoplay:focus-visible, .epv-autoplay:focus-within, .epv-autoplay:active, .epv-autoplay:hover {
  border: 0 !important;
  outline: 0 !important;
  outline-color: transparent !important;
  box-shadow: none !important;
  background: transparent !important;
}
.epv-autoplay .epv-autoplay-label {
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
}

.epv-autoplay-track {
  position: relative;
  display: inline-flex;
  align-items: center;
  width: 42px;
  height: 24px;
  border-radius: 999px;
  background: #e2e8f0;
  transition: background-color 0.2s ease;
  flex: 0 0 auto;
  padding: 0;
  margin: 0;
  border: 0 !important;
  outline: 0 !important;
  box-shadow: none !important;
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
}
.epv-autoplay-track .epv-autoplay-thumb {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;
  border: 0 !important;
  outline: 0 !important;
  pointer-events: none;
}
.epv-autoplay-track .epv-autoplay-thumb mat-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
  color: #64748b;
  pointer-events: none;
}

.epv-autoplay.active .epv-autoplay-track {
  background: #5ea1d8;
}
.epv-autoplay.active .epv-autoplay-track .epv-autoplay-thumb {
  transform: translateX(18px);
}
.epv-autoplay.active .epv-autoplay-track .epv-autoplay-thumb mat-icon {
  color: #5ea1d8;
}

/* ---------- Media canvas (16:9) ---------- */
.epv-canvas {
  position: relative;
  width: 100%;
  aspect-ratio: 16/9;
  border-radius: 12px;
  overflow: hidden;
  background: #000;
  touch-action: pan-y pinch-zoom;
  user-select: none;
  -webkit-user-select: none;
}

.epv-media {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* Center translucent play button */
.epv-play-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border: none;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.28);
  transition: background-color 0.2s ease;
}
.epv-play-overlay:hover {
  background: rgba(0, 0, 0, 0.4);
}

.epv-play-circle {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.92);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
}

.epv-play-icon {
  width: 26px;
  height: 26px;
  fill: #0f172a;
  margin-left: 3px;
}

.epv-play-label {
  color: #ffffff;
  font-size: 13px;
  font-weight: 600;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);
}

/* Center navigation arrows */
.epv-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.45);
  color: #ffffff;
  font-size: 28px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
}
.epv-nav span {
  display: block;
  margin-top: -2px;
}
.epv-nav:hover {
  background: rgba(0, 0, 0, 0.65);
}

.epv-nav-prev {
  left: 12px;
}

.epv-nav-next {
  right: 12px;
}

/* Inline description below the media */
.epv-description {
  margin-top: 14px;
  padding: 14px 16px;
  background: #f8fafc;
  border: 1px solid #eef2f7;
  border-radius: 12px;
  text-align: left;
  font-size: 14px;
  line-height: 1.6;
  color: #334155;
  max-height: 260px;
  overflow-y: auto;
}
.epv-description ::ng-deep p {
  margin: 0 0 8px;
}
.epv-description ::ng-deep p:last-child {
  margin-bottom: 0;
}

.epv-description-empty {
  margin: 0;
  color: #94a3b8;
}

/* ---------- Bottom controls ---------- */
/* Action bar sits directly below the media */
.epv-controls {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.epv-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  font-size: 13px;
  font-weight: 500;
  color: #334155;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.epv-pill mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.epv-pill:hover {
  background: #eef2f7;
}
.epv-pill.active {
  background: #0284c7;
  border-color: #0284c7;
  color: #ffffff;
}
.epv-pill.active mat-icon {
  color: #ffffff;
}

/* ---------- Selection panel (opens over the video) ---------- */
.epv-panel {
  position: absolute;
  left: 12px;
  right: 12px;
  bottom: 12px;
  max-height: 70%;
  display: flex;
  flex-direction: column;
  background: rgba(255, 255, 255, 0.97);
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.28);
  overflow: hidden;
  z-index: 3;
}

.epv-panel-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  border-bottom: 1px solid #eef2f7;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #64748b;
}

.epv-panel-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  color: #64748b;
  cursor: pointer;
  padding: 2px;
  border-radius: 6px;
}
.epv-panel-close mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.epv-panel-close:hover {
  background: #f1f5f9;
}

.epv-panel-scroll {
  overflow-y: auto;
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}
.epv-panel-scroll::-webkit-scrollbar {
  width: 6px;
}
.epv-panel-scroll::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 999px;
}
.epv-panel-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.epv-panel-row {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  text-align: left;
  padding: 10px;
  background: #ffffff;
  border: 1px solid #f1f5f9;
  border-radius: 10px;
  cursor: pointer;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.epv-panel-row:hover {
  border-color: #93c5fd;
}
.epv-panel-row.active {
  border-color: #2563eb;
  box-shadow: 0 0 0 1px #2563eb inset;
}

.epv-row-num {
  width: 20px;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  color: #94a3b8;
  flex: 0 0 auto;
}

.epv-row-icon {
  width: 36px;
  height: 36px;
  flex: 0 0 auto;
  border-radius: 9px;
  background: #f8fafc;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

.epv-row-text {
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.epv-row-title {
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.epv-row-sub {
  margin-top: 2px;
  font-size: 12px;
  color: #64748b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ---------- Mobile: fit viewport width, ignore embed iframe dimensions ---------- */
@media (max-width: 768px) {
  .embed-preview {
    width: 100%;
    max-width: 100%;
    padding: 6px;
    border-radius: 12px;
    margin: 0;
  }
  .epv-player {
    padding: 10px;
  }
  .epv-title-row {
    gap: 8px;
  }
  .epv-meta-row {
    gap: 12px;
    flex-wrap: nowrap;
  }
  .epv-autoplay {
    margin-left: auto;
  }
  .epv-steptitle {
    white-space: normal;
    overflow: visible;
    text-overflow: unset;
  }
  .epv-controls {
    gap: 6px;
  }
  .epv-pill {
    padding: 6px 10px;
    font-size: 12px;
  }
}
/* ---------- Dark theme parity with the rest of the app ---------- */
:host-context(body.theme-dark) {
  /* Material / SVG icons — keep visible on dark surfaces */
}
:host-context(body.theme-dark) .embed-preview {
  background: #0f172a !important;
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .epv-player {
  background: #111827 !important;
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .epv-title {
  color: #f8fafc !important;
}
:host-context(body.theme-dark) .epv-author,
:host-context(body.theme-dark) .epv-autoplay .epv-autoplay-label {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .epv-steptitle {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .epv-autoplay-track {
  background: #374151 !important;
}
:host-context(body.theme-dark) .epv-autoplay-track .epv-autoplay-thumb {
  background: #1f2937 !important;
}
:host-context(body.theme-dark) .epv-autoplay-track .epv-autoplay-thumb mat-icon {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .epv-autoplay.active .epv-autoplay-track {
  background: #5ea1d8 !important;
}
:host-context(body.theme-dark) .epv-autoplay.active .epv-autoplay-track .epv-autoplay-thumb {
  background: #ffffff !important;
}
:host-context(body.theme-dark) .epv-autoplay.active .epv-autoplay-track .epv-autoplay-thumb mat-icon {
  color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .epv-pill {
  background: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .epv-pill mat-icon,
:host-context(body.theme-dark) .epv-pill span {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .epv-pill:hover {
  background: #374151 !important;
}
:host-context(body.theme-dark) .epv-pill.active {
  background: #0284c7 !important;
  border-color: #0284c7 !important;
  color: #ffffff !important;
}
:host-context(body.theme-dark) .epv-pill.active mat-icon,
:host-context(body.theme-dark) .epv-pill.active span {
  color: #ffffff !important;
}
:host-context(body.theme-dark) .epv-description {
  background: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .epv-description ::ng-deep p,
:host-context(body.theme-dark) .epv-description ::ng-deep span,
:host-context(body.theme-dark) .epv-description ::ng-deep li,
:host-context(body.theme-dark) .epv-description ::ng-deep div {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .epv-description-empty {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .epv-panel {
  background: rgba(17, 24, 39, 0.98) !important;
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .epv-panel-head {
  border-bottom-color: rgba(148, 163, 184, 0.2) !important;
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .epv-panel-head span {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .epv-panel-close {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .epv-panel-close mat-icon {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .epv-panel-close:hover {
  background: rgba(148, 163, 184, 0.12) !important;
}
:host-context(body.theme-dark) .epv-panel-row {
  background: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .epv-row-num,
:host-context(body.theme-dark) .epv-row-sub {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .epv-row-title {
  color: #f8fafc !important;
}
:host-context(body.theme-dark) .epv-row-icon {
  background: #0f172a !important;
}
:host-context(body.theme-dark) mat-icon,
:host-context(body.theme-dark) .mat-icon {
  color: #e2e8f0 !important;
  fill: currentColor !important;
}
:host-context(body.theme-dark) .epv-pill.active mat-icon,
:host-context(body.theme-dark) .epv-pill.active .mat-icon {
  color: #ffffff !important;
  fill: currentColor !important;
}
:host-context(body.theme-dark) .epv-autoplay.active .epv-autoplay-track mat-icon,
:host-context(body.theme-dark) .epv-autoplay.active .epv-autoplay-track .mat-icon {
  color: #5ea1d8 !important;
  fill: currentColor !important;
}
:host-context(body.theme-dark) .epv-nav,
:host-context(body.theme-dark) .epv-nav span {
  color: #ffffff !important;
}
:host-context(body.theme-dark) .epv-play-circle {
  background: rgba(255, 255, 255, 0.92) !important;
}
:host-context(body.theme-dark) .epv-play-icon {
  fill: #0f172a !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/embed-preview/embed-preview.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,+DAAA;AAEF;;AACA,kEAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,4CAAA;AAEF;;AACA;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,4CAAA;EACA,sBAAA;EACA,YAAA;AAEF;;AACA;EACE,mBAAA;EACA,gBAAA;AAEF;;AACA,eAAA;AACA;EACE,aAAA;EACA,uBAAA;EACA,2BAAA;AAEF;;AACA;EACE,SAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,kCAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAEF;AAAE;EACE,mBAAA;EACA,iBAAA;EACA,oBAAA;AAEJ;AACE;EACE,eAAA;AACJ;AAEE;EACE,0BAAA;EACA,mBAAA;EACA,kBAAA;AAAJ;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;EACA,WAAA;AADF;;AAIA;EACE,SAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;EACA,YAAA;AADF;;AAIA,2CAAA;AACA;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AADF;;AAIA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,iBAAA;EACA,UAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,2BAAA;EACA,kCAAA;EACA,wCAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AADF;AAGE;EAKE,oBAAA;EACA,qBAAA;EACA,qCAAA;EACA,2BAAA;EACA,kCAAA;AALJ;AAQE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;EACA,yBAAA;UAAA,iBAAA;AANJ;;AAUA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,sCAAA;EACA,cAAA;EACA,UAAA;EACA,SAAA;EACA,oBAAA;EACA,qBAAA;EACA,2BAAA;EACA,oBAAA;EACA,yBAAA;UAAA,iBAAA;AAPF;AASE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,yCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,oBAAA;EACA,qBAAA;EACA,oBAAA;AAPJ;AASI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;AAPN;;AAYA;EACE,mBAAA;AATF;AAWE;EACE,2BAAA;AATJ;AAWI;EACE,cAAA;AATN;;AAcA,8CAAA;AACA;EACE,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,8BAAA;EACA,iBAAA;EACA,yBAAA;AAXF;;AAcA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AAXF;;AAcA,mCAAA;AACA;EACE,kBAAA;EACA,QAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,+BAAA;EACA,sCAAA;AAXF;AAaE;EACE,8BAAA;AAXJ;;AAeA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0CAAA;AAZF;;AAeA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;AAZF;;AAeA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yCAAA;AAZF;;AAeA,6BAAA;AACA;EACE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,+BAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sCAAA;AAZF;AAcE;EACE,cAAA;EACA,gBAAA;AAZJ;AAeE;EACE,+BAAA;AAbJ;;AAiBA;EACE,UAAA;AAdF;;AAiBA;EACE,WAAA;AAdF;;AAiBA,uCAAA;AACA;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AAdF;AAgBE;EACE,eAAA;AAdJ;AAgBE;EACE,gBAAA;AAdJ;;AAkBA;EACE,SAAA;EACA,cAAA;AAfF;;AAkBA,0CAAA;AACA,6CAAA;AACA;EACE,gBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;AAfF;;AAkBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,sCAAA;AAfF;AAiBE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAfJ;AAkBE;EACE,mBAAA;AAhBJ;AAmBE;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AAjBJ;AAmBI;EACE,cAAA;AAjBN;;AAsBA,iEAAA;AACA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,qCAAA;EACA,mBAAA;EACA,0CAAA;EACA,gBAAA;EACA,UAAA;AAnBF;;AAsBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;AAnBF;;AAsBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;AAnBF;AAqBE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAnBJ;AAsBE;EACE,mBAAA;AApBJ;;AAwBA;EACE,gBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EAEA,qBAAA;EACA,oCAAA;AAtBF;AAwBE;EACE,UAAA;AAtBJ;AAwBE;EACE,mBAAA;EACA,oBAAA;AAtBJ;AAwBE;EACE,uBAAA;AAtBJ;;AA0BA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,wDAAA;AAvBF;AAyBE;EACE,qBAAA;AAvBJ;AA0BE;EACE,qBAAA;EACA,mCAAA;AAxBJ;;AA4BA;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;AAzBF;;AA4BA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAzBF;;AA4BA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;AAzBF;;AA4BA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAzBF;;AA4BA;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAzBF;;AA4BA,qFAAA;AACA;EACE;IACE,WAAA;IACA,eAAA;IACA,YAAA;IACA,mBAAA;IACA,SAAA;EAzBF;EA4BA;IACE,aAAA;EA1BF;EA6BA;IACE,QAAA;EA3BF;EA8BA;IACE,SAAA;IACA,iBAAA;EA5BF;EA+BA;IACE,iBAAA;EA7BF;EAgCA;IACE,mBAAA;IACA,iBAAA;IACA,oBAAA;EA9BF;EAiCA;IACE,QAAA;EA/BF;EAkCA;IACE,iBAAA;IACA,eAAA;EAhCF;AACF;AAmCA,qEAAA;AACA;EAuIE,yDAAA;AAvKF;AAiCE;EACE,8BAAA;EACA,yBAAA;AA/BJ;AAkCE;EACE,8BAAA;EACA,yBAAA;AAhCJ;AAmCE;EACE,yBAAA;AAjCJ;AAoCE;;EAEE,yBAAA;AAlCJ;AAqCE;EACE,yBAAA;AAnCJ;AAsCE;EACE,8BAAA;AApCJ;AAuCE;EACE,8BAAA;AArCJ;AAuCI;EACE,yBAAA;AArCN;AAyCE;EACE,8BAAA;AAvCJ;AAyCI;EACE,8BAAA;AAvCN;AAyCM;EACE,yBAAA;AAvCR;AA4CE;EACE,8BAAA;EACA,iDAAA;EACA,yBAAA;AA1CJ;AA4CI;;EAEE,yBAAA;AA1CN;AA6CI;EACE,8BAAA;AA3CN;AA8CI;EACE,8BAAA;EACA,gCAAA;EACA,yBAAA;AA5CN;AA8CM;;EAEE,yBAAA;AA5CR;AAiDE;EACE,8BAAA;EACA,kDAAA;EACA,yBAAA;AA/CJ;AAiDI;;;;EAIE,yBAAA;AA/CN;AAmDE;EACE,yBAAA;AAjDJ;AAoDE;EACE,6CAAA;EACA,yBAAA;AAlDJ;AAqDE;EACE,wDAAA;EACA,yBAAA;AAnDJ;AAqDI;EACE,yBAAA;AAnDN;AAuDE;EACE,yBAAA;AArDJ;AAuDI;EACE,yBAAA;AArDN;AAwDI;EACE,gDAAA;AAtDN;AA0DE;EACE,8BAAA;EACA,iDAAA;AAxDJ;AA2DE;;EAEE,yBAAA;AAzDJ;AA4DE;EACE,yBAAA;AA1DJ;AA6DE;EACE,8BAAA;AA3DJ;AA+DE;;EAEE,yBAAA;EACA,6BAAA;AA7DJ;AAgEE;;EAEE,yBAAA;EACA,6BAAA;AA9DJ;AAiEE;;EAEE,yBAAA;EACA,6BAAA;AA/DJ;AAkEE;;EAEE,yBAAA;AAhEJ;AAmEE;EACE,gDAAA;AAjEJ;AAoEE;EACE,wBAAA;AAlEJ","sourcesContent":[":host {\n  display: block;\n  width: 100%;\n  min-width: 0;\n  max-width: 100%;\n  overflow-x: hidden;\n  box-sizing: border-box;\n  font-family: \"Segoe UI\", \"Roboto\", Helvetica, Arial, sans-serif;\n}\n\n/* ---------- Main wrapper: single-column player card ---------- */\n.embed-preview {\n  padding: 10px;\n  background: #f1f5f9;\n  border-radius: 20px;\n  max-width: 720px;\n  margin: 0 auto;\n  box-sizing: border-box;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);\n}\n\n.epv-player {\n  background: #ffffff;\n  padding: 15px;\n  border-radius: 14px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n  box-sizing: border-box;\n  min-width: 0;\n}\n\n.epv-header {\n  margin-bottom: 16px;\n  text-align: left;\n}\n\n/* Flow title */\n.epv-title-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n\n.epv-title {\n  margin: 0;\n  width: 100%;\n  min-width: 0;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 1.3;\n  color: #0f0f0f;\n  font-family: \"Raleway\", sans-serif;\n  letter-spacing: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  &--expanded {\n    white-space: normal;\n    overflow: visible;\n    text-overflow: unset;\n  }\n\n  &--clickable {\n    cursor: pointer;\n  }\n\n  &--clickable:focus-visible {\n    outline: 2px solid #0284c7;\n    outline-offset: 2px;\n    border-radius: 4px;\n  }\n}\n\n.epv-meta-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-top: 4px;\n  width: 100%;\n}\n\n.epv-author {\n  margin: 0;\n  font-size: 13px;\n  color: #64748b;\n  flex: 0 1 auto;\n  min-width: 0;\n}\n\n/* Step title line (below the flow title) */\n.epv-steptitle {\n  display: block;\n  margin-top: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #000000;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.epv-autoplay {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  flex: 0 0 auto;\n  margin-left: auto;\n  padding: 0;\n  margin-bottom: 0;\n  border: 0 !important;\n  outline: 0 !important;\n  box-shadow: none !important;\n  background: transparent !important;\n  -webkit-tap-highlight-color: transparent;\n  cursor: pointer;\n  user-select: none;\n\n  &:focus,\n  &:focus-visible,\n  &:focus-within,\n  &:active,\n  &:hover {\n    border: 0 !important;\n    outline: 0 !important;\n    outline-color: transparent !important;\n    box-shadow: none !important;\n    background: transparent !important;\n  }\n\n  .epv-autoplay-label {\n    font-size: 12px;\n    font-weight: 600;\n    color: #64748b;\n    pointer-events: none;\n    user-select: none;\n  }\n}\n\n.epv-autoplay-track {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  width: 42px;\n  height: 24px;\n  border-radius: 999px;\n  background: #e2e8f0;\n  transition: background-color 0.2s ease;\n  flex: 0 0 auto;\n  padding: 0;\n  margin: 0;\n  border: 0 !important;\n  outline: 0 !important;\n  box-shadow: none !important;\n  pointer-events: none;\n  user-select: none;\n\n  .epv-autoplay-thumb {\n    position: absolute;\n    top: 2px;\n    left: 2px;\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    background: #ffffff;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: transform 0.2s ease;\n    border: 0 !important;\n    outline: 0 !important;\n    pointer-events: none;\n\n    mat-icon {\n      font-size: 14px;\n      width: 14px;\n      height: 14px;\n      color: #64748b;\n      pointer-events: none;\n    }\n  }\n}\n\n.epv-autoplay.active .epv-autoplay-track {\n  background: #5ea1d8;\n\n  .epv-autoplay-thumb {\n    transform: translateX(18px);\n\n    mat-icon {\n      color: #5ea1d8;\n    }\n  }\n}\n\n/* ---------- Media canvas (16:9) ---------- */\n.epv-canvas {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 16 / 9;\n  border-radius: 12px;\n  overflow: hidden;\n  background: #000;\n  touch-action: pan-y pinch-zoom;\n  user-select: none;\n  -webkit-user-select: none;\n}\n\n.epv-media {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n/* Center translucent play button */\n.epv-play-overlay {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  border: none;\n  cursor: pointer;\n  background: rgba(0, 0, 0, 0.28);\n  transition: background-color 0.2s ease;\n\n  &:hover {\n    background: rgba(0, 0, 0, 0.4);\n  }\n}\n\n.epv-play-circle {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.92);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);\n}\n\n.epv-play-icon {\n  width: 26px;\n  height: 26px;\n  fill: #0f172a;\n  margin-left: 3px;\n}\n\n.epv-play-label {\n  color: #ffffff;\n  font-size: 13px;\n  font-weight: 600;\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);\n}\n\n/* Center navigation arrows */\n.epv-nav {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 2;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: none;\n  cursor: pointer;\n  background: rgba(0, 0, 0, 0.45);\n  color: #ffffff;\n  font-size: 28px;\n  line-height: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s ease;\n\n  span {\n    display: block;\n    margin-top: -2px;\n  }\n\n  &:hover {\n    background: rgba(0, 0, 0, 0.65);\n  }\n}\n\n.epv-nav-prev {\n  left: 12px;\n}\n\n.epv-nav-next {\n  right: 12px;\n}\n\n/* Inline description below the media */\n.epv-description {\n  margin-top: 14px;\n  padding: 14px 16px;\n  background: #f8fafc;\n  border: 1px solid #eef2f7;\n  border-radius: 12px;\n  text-align: left;\n  font-size: 14px;\n  line-height: 1.6;\n  color: #334155;\n  max-height: 260px;\n  overflow-y: auto;\n\n  ::ng-deep p {\n    margin: 0 0 8px;\n  }\n  ::ng-deep p:last-child {\n    margin-bottom: 0;\n  }\n}\n\n.epv-description-empty {\n  margin: 0;\n  color: #94a3b8;\n}\n\n/* ---------- Bottom controls ---------- */\n/* Action bar sits directly below the media */\n.epv-controls {\n  margin-top: 10px;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n}\n\n.epv-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #334155;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n\n  mat-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n  }\n\n  &:hover {\n    background: #eef2f7;\n  }\n\n  &.active {\n    background: #0284c7;\n    border-color: #0284c7;\n    color: #ffffff;\n\n    mat-icon {\n      color: #ffffff;\n    }\n  }\n}\n\n/* ---------- Selection panel (opens over the video) ---------- */\n.epv-panel {\n  position: absolute;\n  left: 12px;\n  right: 12px;\n  bottom: 12px;\n  max-height: 70%;\n  display: flex;\n  flex-direction: column;\n  background: rgba(255, 255, 255, 0.97);\n  border-radius: 12px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.28);\n  overflow: hidden;\n  z-index: 3;\n}\n\n.epv-panel-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 12px;\n  border-bottom: 1px solid #eef2f7;\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: #64748b;\n}\n\n.epv-panel-close {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  background: transparent;\n  color: #64748b;\n  cursor: pointer;\n  padding: 2px;\n  border-radius: 6px;\n\n  mat-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n  }\n\n  &:hover {\n    background: #f1f5f9;\n  }\n}\n\n.epv-panel-scroll {\n  overflow-y: auto;\n  padding: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n\n  scrollbar-width: thin;\n  scrollbar-color: #cbd5e1 transparent;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n  &::-webkit-scrollbar-thumb {\n    background: #cbd5e1;\n    border-radius: 999px;\n  }\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n}\n\n.epv-panel-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  text-align: left;\n  padding: 10px;\n  background: #ffffff;\n  border: 1px solid #f1f5f9;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n\n  &:hover {\n    border-color: #93c5fd;\n  }\n\n  &.active {\n    border-color: #2563eb;\n    box-shadow: 0 0 0 1px #2563eb inset;\n  }\n}\n\n.epv-row-num {\n  width: 20px;\n  text-align: center;\n  font-size: 16px;\n  font-weight: 700;\n  color: #94a3b8;\n  flex: 0 0 auto;\n}\n\n.epv-row-icon {\n  width: 36px;\n  height: 36px;\n  flex: 0 0 auto;\n  border-radius: 9px;\n  background: #f8fafc;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n}\n\n.epv-row-text {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.epv-row-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #0f172a;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.epv-row-sub {\n  margin-top: 2px;\n  font-size: 12px;\n  color: #64748b;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* ---------- Mobile: fit viewport width, ignore embed iframe dimensions ---------- */\n@media (max-width: 768px) {\n  .embed-preview {\n    width: 100%;\n    max-width: 100%;\n    padding: 6px;\n    border-radius: 12px;\n    margin: 0;\n  }\n\n  .epv-player {\n    padding: 10px;\n  }\n\n  .epv-title-row {\n    gap: 8px;\n  }\n\n  .epv-meta-row {\n    gap: 12px;\n    flex-wrap: nowrap;\n  }\n\n  .epv-autoplay {\n    margin-left: auto;\n  }\n\n  .epv-steptitle {\n    white-space: normal;\n    overflow: visible;\n    text-overflow: unset;\n  }\n\n  .epv-controls {\n    gap: 6px;\n  }\n\n  .epv-pill {\n    padding: 6px 10px;\n    font-size: 12px;\n  }\n}\n\n/* ---------- Dark theme parity with the rest of the app ---------- */\n:host-context(body.theme-dark) {\n  .embed-preview {\n    background: #0f172a !important;\n    color: #e2e8f0 !important;\n  }\n\n  .epv-player {\n    background: #111827 !important;\n    color: #e2e8f0 !important;\n  }\n\n  .epv-title {\n    color: #f8fafc !important;\n  }\n\n  .epv-author,\n  .epv-autoplay .epv-autoplay-label {\n    color: #94a3b8 !important;\n  }\n\n  .epv-steptitle {\n    color: #e2e8f0 !important;\n  }\n\n  .epv-autoplay-track {\n    background: #374151 !important;\n  }\n\n  .epv-autoplay-track .epv-autoplay-thumb {\n    background: #1f2937 !important;\n\n    mat-icon {\n      color: #cbd5e1 !important;\n    }\n  }\n\n  .epv-autoplay.active .epv-autoplay-track {\n    background: #5ea1d8 !important;\n\n    .epv-autoplay-thumb {\n      background: #ffffff !important;\n\n      mat-icon {\n        color: #5ea1d8 !important;\n      }\n    }\n  }\n\n  .epv-pill {\n    background: #1f2937 !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n    color: #e2e8f0 !important;\n\n    mat-icon,\n    span {\n      color: #e2e8f0 !important;\n    }\n\n    &:hover {\n      background: #374151 !important;\n    }\n\n    &.active {\n      background: #0284c7 !important;\n      border-color: #0284c7 !important;\n      color: #ffffff !important;\n\n      mat-icon,\n      span {\n        color: #ffffff !important;\n      }\n    }\n  }\n\n  .epv-description {\n    background: #1f2937 !important;\n    border-color: rgba(148, 163, 184, 0.25) !important;\n    color: #e2e8f0 !important;\n\n    ::ng-deep p,\n    ::ng-deep span,\n    ::ng-deep li,\n    ::ng-deep div {\n      color: #e2e8f0 !important;\n    }\n  }\n\n  .epv-description-empty {\n    color: #94a3b8 !important;\n  }\n\n  .epv-panel {\n    background: rgba(17, 24, 39, 0.98) !important;\n    color: #e2e8f0 !important;\n  }\n\n  .epv-panel-head {\n    border-bottom-color: rgba(148, 163, 184, 0.2) !important;\n    color: #94a3b8 !important;\n\n    span {\n      color: #94a3b8 !important;\n    }\n  }\n\n  .epv-panel-close {\n    color: #cbd5e1 !important;\n\n    mat-icon {\n      color: #cbd5e1 !important;\n    }\n\n    &:hover {\n      background: rgba(148, 163, 184, 0.12) !important;\n    }\n  }\n\n  .epv-panel-row {\n    background: #1f2937 !important;\n    border-color: rgba(148, 163, 184, 0.2) !important;\n  }\n\n  .epv-row-num,\n  .epv-row-sub {\n    color: #94a3b8 !important;\n  }\n\n  .epv-row-title {\n    color: #f8fafc !important;\n  }\n\n  .epv-row-icon {\n    background: #0f172a !important;\n  }\n\n  /* Material / SVG icons — keep visible on dark surfaces */\n  mat-icon,\n  .mat-icon {\n    color: #e2e8f0 !important;\n    fill: currentColor !important;\n  }\n\n  .epv-pill.active mat-icon,\n  .epv-pill.active .mat-icon {\n    color: #ffffff !important;\n    fill: currentColor !important;\n  }\n\n  .epv-autoplay.active .epv-autoplay-track mat-icon,\n  .epv-autoplay.active .epv-autoplay-track .mat-icon {\n    color: #5ea1d8 !important;\n    fill: currentColor !important;\n  }\n\n  .epv-nav,\n  .epv-nav span {\n    color: #ffffff !important;\n  }\n\n  .epv-play-circle {\n    background: rgba(255, 255, 255, 0.92) !important;\n  }\n\n  .epv-play-icon {\n    fill: #0f172a !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
